module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/collabs-logos/celsius-194e6be8ca0333bd94a7e1375706a193.svg";